import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { Info } from '@vlabs/monokit/shared/ui/info';
import { useTranslation, Trans } from 'react-i18next';

import st from './PermissionTagInfo.module.sass';

export function PermissionTagInfo(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={st.Container}>
      <Info
        hideable
        icon={<InfoCircleFilledIcon className={st.InfoIcon} />}
        title={t('permission-tag-list-page:permission_tag_info.title')}
      >
        <div className={st.Description}>
          <Trans
            components={{
              p: <p />,
              span: <span />,
              ul: <ul />,
              li: <li />,
            }}
            i18nKey="permission-tag-list-page:permission_tag_info.content"
          />
        </div>
      </Info>
    </div>
  );
}
